<template>
  <div>

    <navbar></navbar>

    <div class="bg-header-round-big">
      <div class="container">
        <h1 v-if="category" >{{ category.name }}</h1>
        <category-menu></category-menu>
      </div>
    </div>

    <div v-if="loadingShop" class="flex items-center">
      <div class="flex-1 text-grey-darker text-center px-4 py-4 m-4">
        <cg-loader :show="true"></cg-loader>
      </div>
    </div>

    <vendorlist v-if="category && shopList.data.length" :loading="loadingMore"  v-on:more="loadMore" :title="'Händler Übersicht'" :shops="shopList" :type="'main'"></vendorlist>

    <div class="m-5 p-8" v-if="!shopList.data.length" >
      <h3>Liebe Kunden</h3>
      <h3>Wir bauen diesen Service gerade auf. Bitte habt noch Geduld mit uns! Das Angebot wird schon sehr bald erweitert!</h3>
    </div>

    <benefits></benefits>

    <cgfooter></cgfooter>

  </div>
</template>

<script>
  import Navbar from '../components/Navbar.vue'
  import ShopList from '../components/ShopList.vue'
  import Benefits from '../components/Benefits.vue'
  import CgFooter from '../components/CgFooter.vue'
  import Filter from '../components/modals/Filter.vue'
  import CgLoader from '../components/menus/cgLoader'

  import {mapGetters, mapActions} from 'vuex'
  import helpers from '@/mixins/helpers.js'
  import formatting from '@/mixins/formatting.js'
  import CategoryMenu from '../components/menus/categories'

  export default {
    name: 'shop-category',
    components: {
      CategoryMenu,
      CgLoader,
      'navbar': Navbar,
      'vendorlist': ShopList,
      'benefits': Benefits,
      'cgfooter': CgFooter,
      'modal-filter': Filter
    },
    mixins: [helpers, formatting],
    data () {
      return {
        filterCategories: [],
        category: null,
        loadingShop: true,
        loadingMore: false
      }
    },
    beforeRouteUpdate (to, from, next) {
      next()
      this.init()
    },
    created () {
      this.init()
    },
    methods: {
      init () {
        this.loadingShop = true
        var self = this
        if (!this.categories.length) {
          this.getGlobalCategories({
            cb () {
              self.setCategory()
            }
          })
        } else {
          this.setCategory()
        }
      },
      ...mapActions([
        'getShopListByCat',
        'getMore',
        'getGlobalCategories'
      ]),
      setCategory () {
        var self = this
        var categoryIso = this.$route.params.category
        for (var c in this.categories) {
          if (this.categories[c].iso_name === categoryIso) {
            this.category = this.categories[c]
          }
        }
        if (!this.category) {
          this.$toasted.error('Die gesuchte Kategorie konnte nicht gefunden werden', {
            theme: 'primary',
            position: 'top-right',
            duration: 10000,
            action: {
              text: 'X',
              class: 'toastBtn',
              onClick: (e, toastObject) => {
                toastObject.goAway(0)
              }
            },
            icon: 'close'
          })
          this.goTo('home')
        } else {
          this.getShopListByCat({
            category: this.category.uid,
            cb () {
              self.loadingShop = false
            },
            errorCb () {
              self.loadingShop = false
            }
          })
        }
      },
      loadMore () {
        var self = this
        this.loadingMore = true
        this.getMore({
          url: this.shopList.links.next,
          commit: 'SHOP_LIST_CAT_PAGE',
          cb () {
            self.loadingMore = false
          },
          errorCb () {
            self.loadingMore = false
          }
        })
      }
    },
    computed: {
      ...mapGetters({
        shopList: 'shop_get_list_cat',
        categories: 'global_get_categories'
      })
    }
  }
</script>




// WEBPACK FOOTER //
// src/views/ShopCategory.vue